'use strict';
const angular = require('angular');
import assistants from "./assistants";
import products from "./products";
import services from "./services";
import offers from "./offers";
import shops from "./shops";
import totals from "./totals";

export default angular.module('nomasvelloDashboardApp.manager', [
    assistants,
    products,
    services,
    offers,
    shops,
    totals
])
    .name;



// WEBPACK FOOTER //
// ./client/app/manager/index.ts